import { Bx } from '@curry-group/mui-curcuma';

export const AppFrameContent: React.FC = ({ children }) => {
  return (
    <Bx id="frame__content" gridArea="content" position="relative">
      {children}
    </Bx>
  );
};
